export default __webpack_public_path__ + "static/3-b6f124075ef9712a0d14bf19a80254ad.png";